export default __webpack_public_path__ + "8bfda3d455b864dce5e5928d4058c5cd.svg";